import { create } from 'zustand';

interface EditAdminStore {
  isAdmin: boolean;
  isAdminMode: boolean;
  setIsAdmin: (value: boolean) => void;
  setIsAdminMode: (value: boolean) => void;
}

export const useAdminModeStore = create<EditAdminStore>((set) => ({
  isAdmin: false,
  setIsAdmin: (value) => {
    value === true ?
      set({ isAdmin: true }) :
      set({ isAdmin: false, isAdminMode: false });
  },
  isAdminMode: false,
  setIsAdminMode: (value) => set({ isAdminMode: value }),
}));
